import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  categorizeJobTransactions,
  categorizeJobTransactionsAsync,
  categorizeJobTransactionsAsyncWithTagLevels,
  getAllTags,
  getAsyncTask,
  getCategorizedTransactions,
  getCategorizedTransactionsWithTagLevels,
  getTransactionCategories,
} from "../../docuclipper/api";
import { ReduxState } from "..";

import { setRefreshKey, setTls } from "./TransactionManager";
import { setByCategoryKeyword, setCategories } from "./Categories";
import { createAlert } from "./Alerts";
import { pollForCompletion } from "./AsyncUtils";

export function randomColor(i) {
  const colors = ["#7982B9", "#A5C1DC", "#E9F6FA"];
  return colors[i % colors.length];
}
const initialState: {
  loading: boolean;
  asyncJobId: string | null;
} = {
  loading: false,
  asyncJobId: null,
};

const slice = createSlice({
  name: "CategoriesAsync",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setAsyncJobId(state, action: PayloadAction<string>) {
      state.asyncJobId = action.payload;
    },
  },
});

export const { setAsyncJobId, setLoading } = slice.actions;

export const categorizeActionAsync = ({ l1, l2, tagRegexIds }: { l1?, l2?, tagRegexIds?} = {}) => async (dispatch, getState) => {
  const state: ReduxState = getState();
  if (state.AsyncCategories.loading) {
    return;
  }
  const { job } = state.JobData;

  const jobId = job?.id;
  const { selectedTagRegexesSet } = state.TagRegexes;

  if (!selectedTagRegexesSet) {
    return;
  }
  try {
    dispatch(setLoading(true));
    let asyncJobId;
    if (l1 && l2) {
      const res = await categorizeJobTransactionsAsyncWithTagLevels(
        l1, l2,
        selectedTagRegexesSet.name,
        state.Reconciler.selectedAccountReconciler || '',
        tagRegexIds
      );
      asyncJobId = res.asyncJobId
    } else if (jobId) {
      const res = await categorizeJobTransactionsAsync(
        jobId,
        selectedTagRegexesSet.name,
        state.Reconciler.selectedAccountReconciler || '',
        tagRegexIds
      );
      asyncJobId = res.asyncJobId
    }


    dispatch(setAsyncJobId(asyncJobId));

    const onSuccess = async () => {
      dispatch(setLoading(false));
      let res;
      if (l1 && l2) {
        res = await getCategorizedTransactionsWithTagLevels(
          l1, l2, state.Reconciler.selectedAccountReconciler || ''
        )

      } else if (jobId) {
        res = await getCategorizedTransactions(
          jobId,
          state.Reconciler.selectedAccountReconciler || ''
        );

      }
      const { transactions, categories, byCategoryKeyword } = res;

      dispatch(setTls({ transactions, resetPages: false }));
      dispatch(
        setCategories(
          categories
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((c, i) => ({
              ...c,
              color: randomColor(i),
            }))
        )
      );
      dispatch(
        setByCategoryKeyword(
          byCategoryKeyword
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((c, i) => ({
              ...c,
              color: randomColor(i),
            }))
        )
      );
      // Don't call setRefreshKey() - let the table component purge cache instead
      // to preserve filters and pagination
      dispatch(
        createAlert({
          message: "Transactions categorized successfully",
          timeout: 0,
          type: "success",
        })
      );
    };
    const onFail = async () => {
      dispatch(setLoading(false));
      dispatch(
        createAlert({
          message: "Error categorizing transactions",
          timeout: 0,
          type: "error",
        })
      );
    };
    pollForCompletion(dispatch, asyncJobId, jobId, onSuccess, onFail);

    //   dispatch(setTls({ transactions, resetPages: false }));
    //   dispatch(
    //     setCategories(
    //       categories
    //         .sort((a, b) => a.name.localeCompare(b.name))
    //         .map((c, i) => ({
    //           ...c,
    //           color: randomColor(i),
    //         }))
    //     )
    //   );
  } catch (err: any) {
    dispatch(setLoading(false));
    dispatch(createAlert({
      message: err?.message || 'Error categorizing',
      timeout: 0,
      type: 'error'
    }));
  }
};

export default slice.reducer;
